import { Button } from 'blaze-ui/Button'
import Styles from './StartTourTooltip.module.scss'
import { ArrowRight, Close } from 'blaze-ui/icons'
import { ProgressBar } from 'components/ProgressBar/ProgressBar'
import { Tour, TourStartCard } from '../Types'

type Props = TourStartCard & {
  tour: Tour
  tourName: string
  currentStep: number
  totalSteps: number
  handleClose: () => void
  handleCta: () => void
}

export const StartTourTooltip = (props: Props) => {
  const { currentStep, tour, totalSteps, title, content, tourName, handleClose, handleCta } = props
  const progress = (currentStep / totalSteps) * 100
  const ctaPrefix = currentStep === 0 ? 'Start' : 'Continue'
  const ctaLabel = `${ctaPrefix} ${tourName}`

  return (
    <div data-product-tour={tour} className={Styles.root}>
      <div className={Styles.header}>
        <div>
          <div className={Styles.stepsCompleted}>
            {currentStep}/{totalSteps} Completed
          </div>
          <div className={Styles.progressBar}>
            <ProgressBar percentage={progress} size={4} width="100%" backgroundColor="var(--light-20)" color="#fff" />
          </div>
        </div>
        <div className={Styles.close}>
          <Button data-product-tour-skip onPress={handleClose} size="xs" variant="tertiary" aria-label="Skip Tour">
            <Close size={16} color="#ffffff" />
          </Button>
        </div>
      </div>
      <h3 className={Styles.title}>{title}</h3>
      <p className={Styles.content}>{content}</p>

      <div className={Styles.footer}>
        <Button
          data-product-tour-start
          onPress={handleCta}
          size="xs"
          variant="secondary"
          endIcon={ArrowRight}
          fullWidth
        >
          {ctaLabel}&nbsp;
        </Button>
      </div>
    </div>
  )
}
